import {SettingsState} from "@service/store/types/SettingsState";
import {MutationTree} from "@service/store/types/Store";
import {settingsMutations} from "@service/store/settings/mutations-list";

export const mutations: MutationTree<SettingsState, typeof settingsMutations> = {
    setLanguages(state, payload: string[]) {
        state.languages = payload;
    }
}
